import * as Yup from 'yup';
import CustomModal from '../../../common/components/CustomModal/CustomModal';
import { IModalProps } from '../../../common/interfaces/CustomModal';
import { ICustomFormProps } from '../../../common/interfaces/CustomForm';
import { FC } from 'react';
import IStudentStatus from '../../../interfaces/StudentStatus';
import { studentStatusesFields } from '../../../config/formFields/StudentStatusesFields';
import studentStatusesService from '../../../services/StudentStatusesService';

interface IStudentStatusesModalProps {
    studentStatus: IStudentStatus | undefined,
    id: number | undefined
    show: boolean,
    close: (action?: string) => void,
    action: string
}

const studentStatussModal: FC<IStudentStatusesModalProps> = (props) => {
    const { studentStatus, id, show, close, action } = props

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("* Campo obbligatorio"),
        code: Yup.string().required("* Campo obbligatorio").length(3, "La lunghezza deve essere di 3"),
    })

    const handleSubmit = async (values: IStudentStatus) => {
        const body = { ...values, code: values.code.toUpperCase() }
        if (action === "add") {
            studentStatusesService.post(body).then(() => close("add"))
        }
        if (action === "edit" && id) {
            studentStatusesService.put(id, body).then(() => close("edit"))
        }
    }

    const onConfirm = () => {
        if (action === "delete" && id) {
            studentStatusesService.delete(id).then(() => close("delete"))
        }
    }

    const modalProps: IModalProps = {
        close,
        confirm: onConfirm,
        show,
        action,
        label: studentStatus ? 'Modifica i dati di "' + studentStatus.name + '"' : "Aggiungi un nuovo stato per gli studenti"
    }

    const formProps: ICustomFormProps = {
        close,
        fields: studentStatusesFields,
        initialValues: studentStatus,
        onSubmit: handleSubmit,
        validationSchema
    }

    return <CustomModal modalProps={modalProps} formProps={formProps}></CustomModal>
}

export default studentStatussModal;